import DefaultFormat from './default_format.helper'

export default class JuanPabloGonzalezFormat extends DefaultFormat {
}
